import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/scheme/SleepImproveScheme.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-45f64d2c")

_pushScopeId("data-v-45f64d2c")
const _hoisted_1 = { class: "sleep-improve-box" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", {
    class: "header-top-banner",
    src: _imports_0
  })
], -1)
const _hoisted_3 = { class: "sleep-improve-body" }
const _hoisted_4 = { class: "sleep-improve-body__main" }
const _hoisted_5 = {
  key: 0,
  class: "sleep-improve-item__title"
}
const _hoisted_6 = { class: "sleep-improve-item__body" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("一键支付，查看方案详情")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_col = _resolveComponent("van-col")
  const _component_van_row = _resolveComponent("van-row")
  const _component_van_sticky = _resolveComponent("van-sticky")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "sleep-improve-item",
            key: index
          }, [
            (item.title)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode("span", {
                    textContent: _toDisplayString(item.title)
                  }, null, 8, ["textContent"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_6, [
              (item.isRichText)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    innerHTML: item.content
                  }, null, 8, ["innerHTML"]))
                : (_openBlock(), _createBlock("div", {
                    key: 1,
                    textContent: _toDisplayString(item.content)
                  }, null, 8, ["textContent"]))
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_van_sticky, {
      "offset-bottom": 20,
      position: "bottom",
      "safe-area-inset-bottom": "",
      style: {"margin":"25px 0"}
    }, {
      default: _withId(() => [
        _createVNode(_component_van_row, null, {
          default: _withId(() => [
            _createVNode(_component_van_col, {
              span: "20",
              offset: "2"
            }, {
              default: _withId(() => [
                _createVNode(_component_van_button, {
                  onClick: _ctx.toPayment,
                  type: "primary",
                  color: "rgb(116, 83, 213)",
                  round: true,
                  size: "normal",
                  block: ""
                }, {
                  default: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})